export const siteName = '麻豆传媒视频';
export const siteTagline = '最新影视资源与精彩视频内容平台';

export interface QuickEntry {
  key: string;
  label: string;
  icon: string;
  desc: string;
  accent: string;
}

export const quickEntries: QuickEntry[] = [
  { key: '电影', label: '电影', icon: 'ri-movie-2-line', desc: '院线品质与经典佳片', accent: 'bg-primary-500' },
  { key: '电视剧', label: '电视剧', icon: 'ri-tv-2-line', desc: '热播剧集每日更新', accent: 'bg-accent-500' },
  { key: '综艺', label: '综艺', icon: 'ri-mic-line', desc: '真人秀与音乐现场', accent: 'bg-secondary-500' },
  { key: '动漫', label: '动漫', icon: 'ri-magic-line', desc: '热血与治愈的二次元', accent: 'bg-primary-700' },
];

export const navLinks = [
  { label: '首页', path: '/' },
  { label: '影视分类', path: '/category' },
  { label: '影视专题', path: '/special' },
];

export const footerGroups = [
  {
    title: '内容导航',
    links: [
      { label: '首页', path: '/' },
      { label: '影视分类', path: '/category' },
      { label: '影视专题', path: '/special' },
    ],
  },
  {
    title: '热门类型',
    links: [
      { label: '电影', path: '/category?type=%E7%94%B5%E5%BD%B1' },
      { label: '电视剧', path: '/category?type=%E7%94%B5%E8%A7%86%E5%89%A7' },
      { label: '综艺', path: '/category?type=%E7%BB%BC%E8%89%BA' },
      { label: '动漫', path: '/category?type=%E5%8A%A8%E6%BC%AB' },
    ],
  },
  {
    title: '关于本站',
    links: [
      { label: '站内简介', path: '/#about' },
      { label: '专题策划', path: '/special' },
      { label: '影视分类', path: '/category' },
    ],
  },
];

export const siteIntro = '麻豆传媒视频是一个聚合电视剧、电影、综艺、动漫等多元内容的影视信息门户。我们以清晰的分类体系、便捷的筛选检索与丰富的内容专题，帮助影迷快速找到感兴趣的影视作品，在信息与兴趣之间搭建一条顺畅的通道。本站内容均为演示数据，不含在线播放与下载功能。';